import { ALT_SCREEN_ON, ALT_SCREEN_OFF, CLEAR_SCREEN, CURSOR_HOME, CURSOR_SHOW, CURSOR_HIDE, MOUSE_CELL_ON, MOUSE_SGR_ON, MOUSE_ALL_ON, MOUSE_CELL_OFF, MOUSE_ALL_OFF, MOUSE_SGR_OFF, BRACKETED_PASTE_ON, BRACKETED_PASTE_OFF, REPORT_FOCUS_ON, REPORT_FOCUS_OFF, allocBytes, concatBytes, decodeString, encodeString, byteLength, decodeFirstRune } from '@boba-cli/machine';

// src/input.ts

// src/messages.ts
var QuitMsg = class {
  _tag = "quit";
};
var InterruptMsg = class {
  _tag = "interrupt";
};
var SuspendMsg = class {
  _tag = "suspend";
};
var ResumeMsg = class {
  _tag = "resume";
};
var WindowSizeMsg = class {
  constructor(width, height) {
    this.width = width;
    this.height = height;
  }
  _tag = "window-size";
};
var FocusMsg = class {
  _tag = "focus";
};
var BlurMsg = class {
  _tag = "blur";
};
var ClearScreenMsg = class {
  _tag = "clear-screen";
};
var EnterAltScreenMsg = class {
  _tag = "enter-alt-screen";
};
var ExitAltScreenMsg = class {
  _tag = "exit-alt-screen";
};
var EnableMouseCellMotionMsg = class {
  _tag = "enable-mouse-cell-motion";
};
var EnableMouseAllMotionMsg = class {
  _tag = "enable-mouse-all-motion";
};
var DisableMouseMsg = class {
  _tag = "disable-mouse";
};
var ShowCursorMsg = class {
  _tag = "show-cursor";
};
var HideCursorMsg = class {
  _tag = "hide-cursor";
};
var EnableReportFocusMsg = class {
  _tag = "enable-report-focus";
};
var DisableReportFocusMsg = class {
  _tag = "disable-report-focus";
};
var SetWindowTitleMsg = class {
  constructor(title) {
    this.title = title;
  }
  _tag = "set-window-title";
};
var KeyType = /* @__PURE__ */ ((KeyType2) => {
  KeyType2["Null"] = "null";
  KeyType2["Break"] = "break";
  KeyType2["Enter"] = "enter";
  KeyType2["Backspace"] = "backspace";
  KeyType2["Tab"] = "tab";
  KeyType2["Esc"] = "esc";
  KeyType2["Space"] = "space";
  KeyType2["Runes"] = "runes";
  KeyType2["Up"] = "up";
  KeyType2["Down"] = "down";
  KeyType2["Right"] = "right";
  KeyType2["Left"] = "left";
  KeyType2["ShiftTab"] = "shift+tab";
  KeyType2["Home"] = "home";
  KeyType2["End"] = "end";
  KeyType2["PgUp"] = "pgup";
  KeyType2["PgDown"] = "pgdown";
  KeyType2["CtrlPgUp"] = "ctrl+pgup";
  KeyType2["CtrlPgDown"] = "ctrl+pgdown";
  KeyType2["Delete"] = "delete";
  KeyType2["Insert"] = "insert";
  KeyType2["CtrlUp"] = "ctrl+up";
  KeyType2["CtrlDown"] = "ctrl+down";
  KeyType2["CtrlRight"] = "ctrl+right";
  KeyType2["CtrlLeft"] = "ctrl+left";
  KeyType2["CtrlHome"] = "ctrl+home";
  KeyType2["CtrlEnd"] = "ctrl+end";
  KeyType2["ShiftUp"] = "shift+up";
  KeyType2["ShiftDown"] = "shift+down";
  KeyType2["ShiftRight"] = "shift+right";
  KeyType2["ShiftLeft"] = "shift+left";
  KeyType2["ShiftHome"] = "shift+home";
  KeyType2["ShiftEnd"] = "shift+end";
  KeyType2["CtrlShiftUp"] = "ctrl+shift+up";
  KeyType2["CtrlShiftDown"] = "ctrl+shift+down";
  KeyType2["CtrlShiftLeft"] = "ctrl+shift+left";
  KeyType2["CtrlShiftRight"] = "ctrl+shift+right";
  KeyType2["CtrlShiftHome"] = "ctrl+shift+home";
  KeyType2["CtrlShiftEnd"] = "ctrl+shift+end";
  KeyType2["F1"] = "f1";
  KeyType2["F2"] = "f2";
  KeyType2["F3"] = "f3";
  KeyType2["F4"] = "f4";
  KeyType2["F5"] = "f5";
  KeyType2["F6"] = "f6";
  KeyType2["F7"] = "f7";
  KeyType2["F8"] = "f8";
  KeyType2["F9"] = "f9";
  KeyType2["F10"] = "f10";
  KeyType2["F11"] = "f11";
  KeyType2["F12"] = "f12";
  KeyType2["F13"] = "f13";
  KeyType2["F14"] = "f14";
  KeyType2["F15"] = "f15";
  KeyType2["F16"] = "f16";
  KeyType2["F17"] = "f17";
  KeyType2["F18"] = "f18";
  KeyType2["F19"] = "f19";
  KeyType2["F20"] = "f20";
  return KeyType2;
})(KeyType || {});
var keyNames = {
  ["null" /* Null */]: "ctrl+@",
  ["break" /* Break */]: "ctrl+c",
  ["enter" /* Enter */]: "enter",
  ["backspace" /* Backspace */]: "backspace",
  ["tab" /* Tab */]: "tab",
  ["esc" /* Esc */]: "esc",
  ["space" /* Space */]: " ",
  ["runes" /* Runes */]: "runes",
  ["up" /* Up */]: "up",
  ["down" /* Down */]: "down",
  ["right" /* Right */]: "right",
  ["left" /* Left */]: "left",
  ["shift+tab" /* ShiftTab */]: "shift+tab",
  ["home" /* Home */]: "home",
  ["end" /* End */]: "end",
  ["pgup" /* PgUp */]: "pgup",
  ["pgdown" /* PgDown */]: "pgdown",
  ["ctrl+pgup" /* CtrlPgUp */]: "ctrl+pgup",
  ["ctrl+pgdown" /* CtrlPgDown */]: "ctrl+pgdown",
  ["delete" /* Delete */]: "delete",
  ["insert" /* Insert */]: "insert",
  ["ctrl+up" /* CtrlUp */]: "ctrl+up",
  ["ctrl+down" /* CtrlDown */]: "ctrl+down",
  ["ctrl+right" /* CtrlRight */]: "ctrl+right",
  ["ctrl+left" /* CtrlLeft */]: "ctrl+left",
  ["ctrl+home" /* CtrlHome */]: "ctrl+home",
  ["ctrl+end" /* CtrlEnd */]: "ctrl+end",
  ["shift+up" /* ShiftUp */]: "shift+up",
  ["shift+down" /* ShiftDown */]: "shift+down",
  ["shift+right" /* ShiftRight */]: "shift+right",
  ["shift+left" /* ShiftLeft */]: "shift+left",
  ["shift+home" /* ShiftHome */]: "shift+home",
  ["shift+end" /* ShiftEnd */]: "shift+end",
  ["ctrl+shift+up" /* CtrlShiftUp */]: "ctrl+shift+up",
  ["ctrl+shift+down" /* CtrlShiftDown */]: "ctrl+shift+down",
  ["ctrl+shift+left" /* CtrlShiftLeft */]: "ctrl+shift+left",
  ["ctrl+shift+right" /* CtrlShiftRight */]: "ctrl+shift+right",
  ["ctrl+shift+home" /* CtrlShiftHome */]: "ctrl+shift+home",
  ["ctrl+shift+end" /* CtrlShiftEnd */]: "ctrl+shift+end",
  ["f1" /* F1 */]: "f1",
  ["f2" /* F2 */]: "f2",
  ["f3" /* F3 */]: "f3",
  ["f4" /* F4 */]: "f4",
  ["f5" /* F5 */]: "f5",
  ["f6" /* F6 */]: "f6",
  ["f7" /* F7 */]: "f7",
  ["f8" /* F8 */]: "f8",
  ["f9" /* F9 */]: "f9",
  ["f10" /* F10 */]: "f10",
  ["f11" /* F11 */]: "f11",
  ["f12" /* F12 */]: "f12",
  ["f13" /* F13 */]: "f13",
  ["f14" /* F14 */]: "f14",
  ["f15" /* F15 */]: "f15",
  ["f16" /* F16 */]: "f16",
  ["f17" /* F17 */]: "f17",
  ["f18" /* F18 */]: "f18",
  ["f19" /* F19 */]: "f19",
  ["f20" /* F20 */]: "f20"
};
var controlKeyMap = {
  0: "null" /* Null */,
  3: "break" /* Break */,
  9: "tab" /* Tab */,
  10: "enter" /* Enter */,
  13: "enter" /* Enter */,
  27: "esc" /* Esc */,
  127: "backspace" /* Backspace */
};
var sequences = [
  ["\x1B[A", { type: "up" /* Up */, runes: "", alt: false, paste: false }],
  ["\x1B[B", { type: "down" /* Down */, runes: "", alt: false, paste: false }],
  ["\x1B[C", { type: "right" /* Right */, runes: "", alt: false, paste: false }],
  ["\x1B[D", { type: "left" /* Left */, runes: "", alt: false, paste: false }],
  ["\x1B[Z", { type: "shift+tab" /* ShiftTab */, runes: "", alt: false, paste: false }],
  ["\x1B[2~", { type: "insert" /* Insert */, runes: "", alt: false, paste: false }],
  ["\x1B[3~", { type: "delete" /* Delete */, runes: "", alt: false, paste: false }],
  ["\x1B[5~", { type: "pgup" /* PgUp */, runes: "", alt: false, paste: false }],
  ["\x1B[6~", { type: "pgdown" /* PgDown */, runes: "", alt: false, paste: false }],
  ["\x1B[1~", { type: "home" /* Home */, runes: "", alt: false, paste: false }],
  ["\x1B[4~", { type: "end" /* End */, runes: "", alt: false, paste: false }],
  ["\x1B[H", { type: "home" /* Home */, runes: "", alt: false, paste: false }],
  ["\x1B[F", { type: "end" /* End */, runes: "", alt: false, paste: false }],
  ["\x1BOP", { type: "f1" /* F1 */, runes: "", alt: false, paste: false }],
  ["\x1BOQ", { type: "f2" /* F2 */, runes: "", alt: false, paste: false }],
  ["\x1BOR", { type: "f3" /* F3 */, runes: "", alt: false, paste: false }],
  ["\x1BOS", { type: "f4" /* F4 */, runes: "", alt: false, paste: false }],
  ["\x1B[15~", { type: "f5" /* F5 */, runes: "", alt: false, paste: false }],
  ["\x1B[17~", { type: "f6" /* F6 */, runes: "", alt: false, paste: false }],
  ["\x1B[18~", { type: "f7" /* F7 */, runes: "", alt: false, paste: false }],
  ["\x1B[19~", { type: "f8" /* F8 */, runes: "", alt: false, paste: false }],
  ["\x1B[20~", { type: "f9" /* F9 */, runes: "", alt: false, paste: false }],
  ["\x1B[21~", { type: "f10" /* F10 */, runes: "", alt: false, paste: false }],
  ["\x1B[23~", { type: "f11" /* F11 */, runes: "", alt: false, paste: false }],
  ["\x1B[24~", { type: "f12" /* F12 */, runes: "", alt: false, paste: false }],
  [
    "\x1B[1;2A",
    { type: "shift+up" /* ShiftUp */, runes: "", alt: false, paste: false }
  ],
  [
    "\x1B[1;2B",
    { type: "shift+down" /* ShiftDown */, runes: "", alt: false, paste: false }
  ],
  [
    "\x1B[1;2C",
    { type: "shift+right" /* ShiftRight */, runes: "", alt: false, paste: false }
  ],
  [
    "\x1B[1;2D",
    { type: "shift+left" /* ShiftLeft */, runes: "", alt: false, paste: false }
  ],
  [
    "\x1B[1;5A",
    { type: "ctrl+up" /* CtrlUp */, runes: "", alt: false, paste: false }
  ],
  [
    "\x1B[1;5B",
    { type: "ctrl+down" /* CtrlDown */, runes: "", alt: false, paste: false }
  ],
  [
    "\x1B[1;5C",
    { type: "ctrl+right" /* CtrlRight */, runes: "", alt: false, paste: false }
  ],
  [
    "\x1B[1;5D",
    { type: "ctrl+left" /* CtrlLeft */, runes: "", alt: false, paste: false }
  ],
  [
    "\x1B[1;6A",
    { type: "ctrl+shift+up" /* CtrlShiftUp */, runes: "", alt: false, paste: false }
  ],
  [
    "\x1B[1;6B",
    { type: "ctrl+shift+down" /* CtrlShiftDown */, runes: "", alt: false, paste: false }
  ],
  [
    "\x1B[1;6C",
    { type: "ctrl+shift+right" /* CtrlShiftRight */, runes: "", alt: false, paste: false }
  ],
  [
    "\x1B[1;6D",
    { type: "ctrl+shift+left" /* CtrlShiftLeft */, runes: "", alt: false, paste: false }
  ],
  ["\x1B[1;3A", { type: "up" /* Up */, runes: "", alt: true, paste: false }],
  ["\x1B[1;3B", { type: "down" /* Down */, runes: "", alt: true, paste: false }],
  ["\x1B[1;3C", { type: "right" /* Right */, runes: "", alt: true, paste: false }],
  ["\x1B[1;3D", { type: "left" /* Left */, runes: "", alt: true, paste: false }],
  [
    "\x1B[5;5~",
    { type: "ctrl+pgup" /* CtrlPgUp */, runes: "", alt: false, paste: false }
  ],
  [
    "\x1B[6;5~",
    { type: "ctrl+pgdown" /* CtrlPgDown */, runes: "", alt: false, paste: false }
  ],
  ["\x1B[5;3~", { type: "pgup" /* PgUp */, runes: "", alt: true, paste: false }],
  ["\x1B[6;3~", { type: "pgdown" /* PgDown */, runes: "", alt: true, paste: false }],
  ["\x1B[3;2~", { type: "insert" /* Insert */, runes: "", alt: true, paste: false }],
  ["\x1B[3;3~", { type: "delete" /* Delete */, runes: "", alt: true, paste: false }],
  ["\x1B[[A", { type: "f1" /* F1 */, runes: "", alt: false, paste: false }],
  ["\x1B[[B", { type: "f2" /* F2 */, runes: "", alt: false, paste: false }],
  ["\x1B[[C", { type: "f3" /* F3 */, runes: "", alt: false, paste: false }],
  ["\x1B[[D", { type: "f4" /* F4 */, runes: "", alt: false, paste: false }],
  ["\x1B[[E", { type: "f5" /* F5 */, runes: "", alt: false, paste: false }]
];
var KeyMsg = class {
  constructor(key) {
    this.key = key;
  }
  _tag = "key";
  toString() {
    return keyToString(this.key);
  }
};
function keyToString(key) {
  if (key.type === "runes" /* Runes */) {
    const value = key.paste ? `[${key.runes}]` : key.runes;
    return key.alt ? `alt+${value}` : value;
  }
  const base = keyNames[key.type] ?? "";
  return key.alt ? `alt+${base}` : base;
}
function parseKey(buffer, allowMoreData) {
  if (buffer.length === 0) {
    return allowMoreData ? { needMore: true } : void 0;
  }
  const input = decodeString(buffer);
  for (const [seq, key] of sequences) {
    if (input.startsWith(seq)) {
      return { key, length: byteLength(seq) };
    }
    if (allowMoreData && seq.startsWith(input)) {
      return { needMore: true };
    }
  }
  if (buffer[0] === 27 && buffer.length > 1) {
    const [rune2, altLength] = decodeFirstRune(buffer, 1);
    if (altLength > 0 && rune2 !== null) {
      return {
        key: { type: "runes" /* Runes */, runes: rune2, alt: true, paste: false },
        length: 1 + altLength
      };
    }
  }
  const code = buffer[0] ?? 0;
  const mapped = Object.prototype.hasOwnProperty.call(
    controlKeyMap,
    code
  ) ? controlKeyMap[code] : void 0;
  if (mapped !== void 0) {
    return {
      key: { type: mapped, runes: "", alt: false, paste: false },
      length: 1
    };
  }
  const [rune, runeLength] = decodeFirstRune(buffer);
  if (runeLength === 0 || rune === null) {
    return allowMoreData ? { needMore: true } : void 0;
  }
  if (rune === " ") {
    return {
      key: { type: "space" /* Space */, runes: rune, alt: false, paste: false },
      length: runeLength
    };
  }
  return {
    key: { type: "runes" /* Runes */, runes: rune, alt: false, paste: false },
    length: runeLength
  };
}
var MouseAction = /* @__PURE__ */ ((MouseAction2) => {
  MouseAction2["Press"] = "press";
  MouseAction2["Release"] = "release";
  MouseAction2["Motion"] = "motion";
  return MouseAction2;
})(MouseAction || {});
var MouseButton = /* @__PURE__ */ ((MouseButton2) => {
  MouseButton2["None"] = "none";
  MouseButton2["Left"] = "left";
  MouseButton2["Middle"] = "middle";
  MouseButton2["Right"] = "right";
  MouseButton2["WheelUp"] = "wheel-up";
  MouseButton2["WheelDown"] = "wheel-down";
  MouseButton2["WheelLeft"] = "wheel-left";
  MouseButton2["WheelRight"] = "wheel-right";
  MouseButton2["Backward"] = "backward";
  MouseButton2["Forward"] = "forward";
  MouseButton2["Button10"] = "button-10";
  MouseButton2["Button11"] = "button-11";
  return MouseButton2;
})(MouseButton || {});
var MouseMsg = class {
  constructor(event) {
    this.event = event;
  }
  _tag = "mouse";
  toString() {
    const parts = [
      this.event.ctrl ? "ctrl" : "",
      this.event.alt ? "alt" : "",
      this.event.shift ? "shift" : ""
    ].filter(Boolean);
    const mods = parts.length > 0 ? `${parts.join("+")}+` : "";
    return `${mods}${this.event.button} ${this.event.action} @${this.event.x},${this.event.y}`;
  }
};
var mouseSGRRegex = /(\d+);(\d+);(\d+)([Mm])/;
var mouseEventX10Len = 6;
var x10MouseByteOffset = 32;
function parseMouse(buffer, allowMoreData) {
  if (buffer.length < 3 || buffer[0] !== 27 || buffer[1] !== 91) {
    return void 0;
  }
  if (buffer[2] === 77) {
    if (buffer.length < mouseEventX10Len) {
      return allowMoreData ? { needMore: true } : void 0;
    }
    const event = parseX10MouseEvent(buffer.subarray(0, mouseEventX10Len));
    return { msg: new MouseMsg(event), length: mouseEventX10Len };
  }
  if (buffer[2] === 60) {
    const slice = decodeString(buffer);
    const match = mouseSGRRegex.exec(slice.slice(3));
    if (!match) {
      return allowMoreData ? { needMore: true } : void 0;
    }
    const event = parseSGRMouseEvent(slice);
    const matchedLength = match[0]?.length ?? 0;
    return { msg: new MouseMsg(event), length: matchedLength + 3 };
  }
  return void 0;
}
function parseSGRMouseEvent(seq) {
  const match = mouseSGRRegex.exec(seq.slice(3));
  if (!match) {
    return defaultMouseEvent();
  }
  const buttonCode = Number.parseInt(match[1] ?? "0", 10);
  const px = Number.parseInt(match[2] ?? "0", 10);
  const py = Number.parseInt(match[3] ?? "0", 10);
  const release = match[4] === "m";
  const event = parseMouseButton(buttonCode, true);
  if (event.action !== "motion" /* Motion */ && !eventIsWheel(event) && release) {
    event.action = "release" /* Release */;
  }
  event.x = px - 1;
  event.y = py - 1;
  return event;
}
function parseX10MouseEvent(buf) {
  const buttonByte = buf[3] ?? 0;
  const c1 = buf[4] ?? 0;
  const c2 = buf[5] ?? 0;
  const event = parseMouseButton(buttonByte, false);
  event.x = c1 - x10MouseByteOffset - 1;
  event.y = c2 - x10MouseByteOffset - 1;
  return event;
}
function parseMouseButton(code, isSGR) {
  let e = code;
  if (!isSGR) {
    e -= x10MouseByteOffset;
  }
  const bitShift = 4;
  const bitAlt = 8;
  const bitCtrl = 16;
  const bitMotion = 32;
  const bitWheel = 64;
  const bitAdd = 128;
  const bitsMask = 3;
  const event = defaultMouseEvent();
  if ((e & bitAdd) !== 0) {
    const extraButtons = {
      0: "backward" /* Backward */,
      1: "forward" /* Forward */,
      2: "button-10" /* Button10 */,
      3: "button-11" /* Button11 */
    };
    event.button = extraButtons[e & bitsMask] ?? "none" /* None */;
  } else if ((e & bitWheel) !== 0) {
    const wheelButtons = {
      0: "wheel-up" /* WheelUp */,
      1: "wheel-down" /* WheelDown */,
      2: "wheel-left" /* WheelLeft */,
      3: "wheel-right" /* WheelRight */
    };
    event.button = wheelButtons[e & bitsMask] ?? "none" /* None */;
  } else {
    const baseButtons = {
      0: "left" /* Left */,
      1: "middle" /* Middle */,
      2: "right" /* Right */,
      3: "none" /* None */
    };
    event.button = baseButtons[e & bitsMask] ?? "none" /* None */;
    if ((e & bitsMask) === bitsMask) {
      event.action = "release" /* Release */;
      event.button = "none" /* None */;
    }
  }
  if ((e & bitMotion) !== 0 && !eventIsWheel(event)) {
    event.action = "motion" /* Motion */;
  }
  event.alt = (e & bitAlt) !== 0;
  event.ctrl = (e & bitCtrl) !== 0;
  event.shift = (e & bitShift) !== 0;
  return event;
}
function eventIsWheel(event) {
  return event.button === "wheel-up" /* WheelUp */ || event.button === "wheel-down" /* WheelDown */ || event.button === "wheel-left" /* WheelLeft */ || event.button === "wheel-right" /* WheelRight */;
}
function defaultMouseEvent() {
  return {
    x: 0,
    y: 0,
    shift: false,
    alt: false,
    ctrl: false,
    action: "press" /* Press */,
    button: "none" /* None */
  };
}

// src/input.ts
var BRACKET_PASTE_START = "\x1B[200~";
var BRACKET_PASTE_END = "\x1B[201~";
function startInput(options) {
  if (!options.platform) {
    return () => {
    };
  }
  let buffer = allocBytes(0);
  let disposable = null;
  const onData = (data) => {
    buffer = concatBytes(buffer, data);
    buffer = consumeBuffer(buffer, options.onMessage);
  };
  disposable = options.platform.terminal.onInput(onData);
  return () => {
    if (disposable) {
      disposable.dispose();
    }
  };
}
function consumeBuffer(buffer, push) {
  let offset = 0;
  while (offset < buffer.length) {
    const slice = buffer.subarray(offset);
    const result = detectOne(slice, offset + slice.length === buffer.length);
    if (!result || "needMore" in result) {
      break;
    }
    offset += result.length;
    if (result.msg) {
      push(result.msg);
    }
  }
  return buffer.subarray(offset);
}
function detectOne(buffer, allowMoreData) {
  if (buffer.length === 0) {
    return allowMoreData ? { needMore: true } : void 0;
  }
  const mouse = parseMouse(buffer, allowMoreData);
  if (mouse) {
    if ("needMore" in mouse) {
      return mouse;
    }
    return { msg: mouse.msg, length: mouse.length };
  }
  const focus = detectFocus(buffer);
  if (focus) {
    return focus;
  }
  const paste = detectBracketedPaste(buffer, allowMoreData);
  if (paste) {
    return paste;
  }
  const key = parseKey(buffer, allowMoreData);
  if (!key) {
    return void 0;
  }
  if ("needMore" in key) {
    return key;
  }
  return { msg: new KeyMsg(key.key), length: key.length };
}
function detectFocus(buffer) {
  if (buffer.length === 3 && buffer[0] === 27 && buffer[1] === 91) {
    if (buffer[2] === 73) {
      return { msg: new FocusMsg(), length: 3 };
    }
    if (buffer[2] === 79) {
      return { msg: new BlurMsg(), length: 3 };
    }
  }
  return void 0;
}
function detectBracketedPaste(buffer, allowMoreData) {
  const decoder = new TextDecoder("utf-8", { fatal: false });
  const asString = decoder.decode(buffer);
  if (!asString.startsWith(BRACKET_PASTE_START)) {
    return void 0;
  }
  const endIndex = asString.indexOf(
    BRACKET_PASTE_END,
    BRACKET_PASTE_START.length
  );
  if (endIndex === -1) {
    return allowMoreData ? { needMore: true } : void 0;
  }
  const content = asString.slice(BRACKET_PASTE_START.length, endIndex);
  const fullString = BRACKET_PASTE_START + content + BRACKET_PASTE_END;
  const length = encodeString(fullString).length;
  const key = new KeyMsg({
    type: "runes" /* Runes */,
    runes: content,
    alt: false,
    paste: true
  });
  return { msg: key, length };
}
var StandardRenderer = class {
  nextFrame = null;
  lastFrame = "";
  ticker = null;
  terminal;
  frameInterval;
  constructor(options = {}) {
    this.terminal = options.platform?.terminal ?? null;
    const fps = Math.min(Math.max(options.fps ?? 60, 1), 120);
    this.frameInterval = Math.round(1e3 / fps);
  }
  start() {
    if (this.ticker) {
      return;
    }
    this.ticker = setInterval(() => this.flush(), this.frameInterval);
  }
  stop() {
    this.flush();
    if (this.ticker) {
      clearInterval(this.ticker);
      this.ticker = null;
    }
  }
  write(view) {
    this.nextFrame = view ?? "";
  }
  repaint() {
    this.lastFrame = "";
  }
  flush() {
    if (this.nextFrame === null) {
      return;
    }
    const frame = this.nextFrame;
    if (frame === this.lastFrame) {
      return;
    }
    this.lastFrame = frame;
    if (this.terminal) {
      this.terminal.write(`${CLEAR_SCREEN}${CURSOR_HOME}${frame}`);
    }
  }
};
var TerminalController = class {
  rawMode = false;
  altScreen = false;
  bracketedPaste = false;
  focusReporting = false;
  terminal;
  constructor(platform) {
    this.terminal = platform?.terminal ?? null;
  }
  enableRawMode() {
    if (this.terminal && !this.rawMode) {
      this.terminal.enableRawMode();
      this.rawMode = true;
    }
  }
  disableRawMode() {
    if (this.terminal && this.rawMode) {
      this.terminal.disableRawMode();
      this.rawMode = false;
    }
  }
  enterAltScreen() {
    this.write(ALT_SCREEN_ON);
    this.altScreen = true;
  }
  exitAltScreen() {
    this.write(ALT_SCREEN_OFF);
    this.altScreen = false;
  }
  clearScreen() {
    this.write(`${CLEAR_SCREEN}${CURSOR_HOME}`);
  }
  showCursor() {
    this.write(CURSOR_SHOW);
  }
  hideCursor() {
    this.write(CURSOR_HIDE);
  }
  enableMouseCellMotion() {
    this.write(MOUSE_CELL_ON);
    this.write(MOUSE_SGR_ON);
  }
  enableMouseAllMotion() {
    this.write(MOUSE_ALL_ON);
    this.write(MOUSE_SGR_ON);
  }
  disableMouse() {
    this.write(MOUSE_CELL_OFF);
    this.write(MOUSE_ALL_OFF);
    this.write(MOUSE_SGR_OFF);
  }
  enableBracketedPaste() {
    this.write(BRACKETED_PASTE_ON);
    this.bracketedPaste = true;
  }
  disableBracketedPaste() {
    this.write(BRACKETED_PASTE_OFF);
    this.bracketedPaste = false;
  }
  enableReportFocus() {
    this.write(REPORT_FOCUS_ON);
    this.focusReporting = true;
  }
  disableReportFocus() {
    this.write(REPORT_FOCUS_OFF);
    this.focusReporting = false;
  }
  setWindowTitle(title) {
    this.write(`\x1B]0;${title}\x07`);
  }
  cleanup() {
    this.disableMouse();
    if (this.focusReporting) {
      this.disableReportFocus();
    }
    if (this.bracketedPaste) {
      this.disableBracketedPaste();
    }
    this.showCursor();
    if (this.altScreen) {
      this.exitAltScreen();
    }
    this.disableRawMode();
  }
  write(data) {
    if (data.length === 0) {
      return;
    }
    if (this.terminal) {
      this.terminal.write(data);
    }
  }
};

// src/program.ts
var Program = class {
  model;
  terminal;
  renderer;
  opts;
  platform;
  stopInput;
  running = false;
  queue = [];
  draining = false;
  result = null;
  resolveWait;
  constructor(model, options) {
    this.model = model;
    this.opts = options;
    this.platform = options.platform;
    this.terminal = new TerminalController(this.platform);
    this.renderer = new StandardRenderer({
      platform: this.platform,
      fps: this.opts.fps
    });
  }
  async run() {
    this.running = true;
    this.setupTerminal();
    this.setupSignals();
    this.renderer.start();
    try {
      this.runCmd(this.model.init());
      this.renderer.write(this.model.view());
      this.startInputLoop();
      await this.waitUntilDone();
      this.result = { model: this.model };
    } catch (err) {
      this.result = { model: this.model, error: err };
    } finally {
      this.shutdown();
    }
    return this.result ?? { model: this.model };
  }
  waitUntilDone() {
    return new Promise((resolve) => {
      this.resolveWait = resolve;
      if (!this.running) {
        resolve();
      }
    });
  }
  send(msg2) {
    if (!msg2) {
      return;
    }
    this.queue.push(msg2);
    if (!this.draining) {
      void this.drainQueue();
    }
  }
  quit() {
    this.send(new QuitMsg());
  }
  kill() {
    this.running = false;
    this.shutdown();
  }
  drainQueue() {
    if (this.draining) {
      return;
    }
    this.draining = true;
    while (this.running && this.queue.length > 0) {
      const msg2 = this.queue.shift();
      if (msg2 === void 0) {
        continue;
      }
      const consumed = this.handleInternal(msg2);
      if (consumed) {
        continue;
      }
      const [nextModel, cmd] = this.model.update(msg2);
      this.model = nextModel;
      this.runCmd(cmd);
      this.renderer.write(this.model.view());
    }
    this.draining = false;
  }
  handleInternal(msg2) {
    if (msg2 instanceof QuitMsg || msg2 instanceof InterruptMsg) {
      this.running = false;
      if (this.resolveWait) {
        this.resolveWait();
      }
      return true;
    }
    if (msg2 instanceof ClearScreenMsg) {
      this.terminal.clearScreen();
      return false;
    }
    if (msg2 instanceof EnterAltScreenMsg) {
      this.terminal.enterAltScreen();
      this.renderer.repaint();
      return false;
    }
    if (msg2 instanceof ExitAltScreenMsg) {
      this.terminal.exitAltScreen();
      this.renderer.repaint();
      return false;
    }
    if (msg2 instanceof EnableMouseCellMotionMsg) {
      this.terminal.enableMouseCellMotion();
      return false;
    }
    if (msg2 instanceof EnableMouseAllMotionMsg) {
      this.terminal.enableMouseAllMotion();
      return false;
    }
    if (msg2 instanceof DisableMouseMsg) {
      this.terminal.disableMouse();
      return false;
    }
    if (msg2 instanceof ShowCursorMsg) {
      this.terminal.showCursor();
      return false;
    }
    if (msg2 instanceof HideCursorMsg) {
      this.terminal.hideCursor();
      return false;
    }
    if (msg2 instanceof SetWindowTitleMsg) {
      this.terminal.setWindowTitle(msg2.title);
      return false;
    }
    if (msg2 instanceof ResumeMsg) {
      return false;
    }
    return false;
  }
  runCmd(cmd) {
    if (!cmd) {
      return;
    }
    const handleResult = (result) => {
      if (result === null || result === void 0) {
        return;
      }
      if (Array.isArray(result)) {
        for (const msg2 of result) {
          this.send(msg2);
        }
      } else {
        this.send(result);
      }
    };
    try {
      const effect = cmd();
      if (effect instanceof Promise) {
        effect.then(handleResult).catch((err) => {
          console.error(err);
        });
      } else {
        handleResult(effect);
      }
    } catch (err) {
      console.error(err);
    }
  }
  setupTerminal() {
    this.terminal.enableRawMode();
    this.terminal.hideCursor();
    if (this.opts.altScreen) {
      this.terminal.enterAltScreen();
      this.terminal.clearScreen();
    }
    if (this.opts.mouseMode === "cell") {
      this.terminal.enableMouseCellMotion();
    } else if (this.opts.mouseMode === "all") {
      this.terminal.enableMouseAllMotion();
    }
    if (this.opts.bracketedPaste !== false) {
      this.terminal.enableBracketedPaste();
    }
    if (this.opts.reportFocus) {
      this.terminal.enableReportFocus();
    }
  }
  startInputLoop() {
    this.stopInput = startInput({
      platform: this.platform,
      onMessage: (msg2) => this.send(msg2)
    });
  }
  setupSignals() {
    const disposables = [];
    const intDisposable = this.platform.signals.onInterrupt(this.onSigInt);
    const termDisposable = this.platform.signals.onTerminate(this.onSigTerm);
    disposables.push(
      () => intDisposable.dispose(),
      () => termDisposable.dispose()
    );
    const handleResize = (size) => {
      this.send(new WindowSizeMsg(size.columns, size.rows));
    };
    const resizeDisposable = this.platform.terminal.onResize(handleResize);
    disposables.push(() => resizeDisposable.dispose());
    const initialSize = this.platform.terminal.getSize();
    this.send(new WindowSizeMsg(initialSize.columns, initialSize.rows));
    this.disposeSignals = () => {
      for (const dispose of disposables) {
        dispose();
      }
    };
  }
  disposeSignals = null;
  onSigInt = () => {
    this.send(new InterruptMsg());
  };
  onSigTerm = () => {
    this.send(new QuitMsg());
  };
  shutdown() {
    if (this.disposeSignals) {
      this.disposeSignals();
      this.disposeSignals = null;
    }
    if (this.stopInput) {
      this.stopInput();
      this.stopInput = void 0;
    }
    this.renderer.stop();
    this.terminal.cleanup();
    this.platform.dispose();
  }
};

// src/commands.ts
var now = () => /* @__PURE__ */ new Date();
function batch(...cmds) {
  const valid = cmds.filter((cmd) => Boolean(cmd));
  if (valid.length === 0) {
    return null;
  }
  if (valid.length === 1) {
    const [only] = valid;
    return only ?? null;
  }
  return async () => {
    const results = await Promise.all(
      valid.map((cmd) => Promise.resolve(cmd?.()))
    );
    return flatten(results);
  };
}
function sequence(...cmds) {
  const valid = cmds.filter((cmd) => Boolean(cmd));
  if (valid.length === 0) {
    return null;
  }
  if (valid.length === 1) {
    const [only] = valid;
    return only ?? null;
  }
  return async () => {
    const messages = [];
    for (const cmd of valid) {
      const result = await Promise.resolve(cmd?.());
      if (result !== null && result !== void 0) {
        messages.push(result);
      }
    }
    return flatten(messages);
  };
}
function tick(ms, fn) {
  return () => new Promise((resolve) => {
    setTimeout(() => resolve(fn(now())), ms);
  });
}
function every(ms, fn) {
  return () => new Promise((resolve) => {
    const current = now();
    const delay = alignToInterval(current, ms);
    setTimeout(() => resolve(fn(now())), delay);
  });
}
var msg = (value) => () => value;
var quit = () => msg(new QuitMsg());
function flatten(values) {
  const results = [];
  for (const value of values) {
    if (value === null || value === void 0) {
      continue;
    }
    if (Array.isArray(value)) {
      results.push(...value);
    } else {
      results.push(value);
    }
  }
  if (results.length === 0) {
    return null;
  }
  if (results.length === 1) {
    return results[0];
  }
  return results;
}
function alignToInterval(date, ms) {
  const next = new Date(date);
  next.setMilliseconds(0);
  const remainder = date.getTime() % ms;
  return remainder === 0 ? ms : ms - remainder;
}

// src/screen.ts
var clearScreen = () => () => new ClearScreenMsg();
var enableMouseCellMotion = () => () => new EnableMouseCellMotionMsg();
var enableMouseAllMotion = () => () => new EnableMouseAllMotionMsg();
var disableMouse = () => () => new DisableMouseMsg();
var showCursor = () => () => new ShowCursorMsg();
var hideCursor = () => () => new HideCursorMsg();
var setWindowTitle = (title) => () => new SetWindowTitleMsg(title);
var windowSize = (platform) => () => {
  if (platform) {
    const size = platform.terminal.getSize();
    return new WindowSizeMsg(size.columns, size.rows);
  }
  return new WindowSizeMsg(0, 0);
};

export { BlurMsg, ClearScreenMsg, DisableMouseMsg, DisableReportFocusMsg, EnableMouseAllMotionMsg, EnableMouseCellMotionMsg, EnableReportFocusMsg, EnterAltScreenMsg, ExitAltScreenMsg, FocusMsg, HideCursorMsg, InterruptMsg, KeyMsg, KeyType, MouseAction, MouseButton, MouseMsg, Program, QuitMsg, ResumeMsg, SetWindowTitleMsg, ShowCursorMsg, SuspendMsg, WindowSizeMsg, batch, clearScreen, disableMouse, enableMouseAllMotion, enableMouseCellMotion, every, hideCursor, keyToString, msg, quit, sequence, setWindowTitle, showCursor, tick, windowSize };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map